import React from 'react';
import { 
    Show, 
    SimpleShowLayout, 
    TextField,
    ReferenceField,
    DateField,
    NumberField,
    ArrayField,
    Datagrid
} from 'react-admin';

export const FeePaymentShow = props => {
    return (
        <React.Fragment>
            <Show label="Payment Details" {...props}>
                <SimpleShowLayout>
                    <TextField source="id" />
                    <TextField source="receipt_number" label="Receipt Number" />
                    <ReferenceField source="enrollment_id" reference="student-enrollment" label="Enrollment" link="show">
                        <TextField source="enrollment_number" />
                    </ReferenceField>
                    <NumberField source="amount" label="Total Amount" options={{ style: 'currency', currency: 'INR' }} />
                    <TextField source="payment_type" label="Payment Type" />
                    <TextField source="payment_mode" label="Payment Mode" />
                    <DateField source="payment_date" label="Payment Date" />
                    <TextField source="transaction_reference" label="Transaction Reference" />
                    <TextField source="remarks" label="Remarks" />
                    <ReferenceField source="received_by" reference="user" label="Received By">
                        <TextField source="username" />
                    </ReferenceField>
                    <DateField source="created_at" label="Created At" showTime />
                    <ArrayField source="fee_heads" label="Fee Head Breakdown">
                        <Datagrid bulkActionButtons={false}>
                            <TextField source="fee_head" label="Fee Head" />
                            <NumberField source="amount" label="Amount" options={{ style: 'currency', currency: 'INR' }} />
                        </Datagrid>
                    </ArrayField>
                </SimpleShowLayout>
            </Show>
        </React.Fragment>
    );
}
